module.exports = __webpack_public_path__ + "zmenseni-prsou_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_3_after.jpg
// module id = 1281
// module chunks = 0